import type { BlogPost } from '@nucleus-commerce/api-client/admin';

export type BlogPostState = 'live' | 'scheduled' | 'draft';

/** What the storefront does with a saved post. The backend's `live` is the authority. */
export function postState(post: Pick<BlogPost, 'status' | 'live' | 'publishedAt'>): BlogPostState {
  if (post.status === 'draft') return 'draft';
  return post.live ? 'live' : 'scheduled';
}

/**
 * The same question for unsaved form values: published with no date (meaning now) or a date
 * that has passed is live, a future date is scheduled.
 */
export function draftState(
  status: BlogPost['status'],
  publishedAt: string | null,
  now: Date = new Date(),
): BlogPostState {
  if (status === 'draft') return 'draft';
  return publishedAt && new Date(publishedAt) > now ? 'scheduled' : 'live';
}
